import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnMobilePhoneTemplateOptions } from './mobile-phone-template-options.interface';

export interface ISnMobilePhoneFormFieldConfig extends FormlyFieldConfig {
  type: 'mobile-phone';
  templateOptions?: ISnMobilePhoneTemplateOptions;
}
